import React from 'react';

type Props = {
  color?: string;
  width?: number;
  height?: number;
};

export const UserGroupIcon: React.FC<Props> = ({
  color = '#606C77',
  width = 24,
  height = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon">
      <path
        id="Vector"
        d="M16.7872 12.1295C18.1167 12.1295 19.1945 11.0661 19.1945 9.75435C19.1945 8.44259 18.1167 7.3792 16.7872 7.3792M19.4237 17.5482L19.6596 17.5815C20.3671 17.6812 21 17.1396 21 16.4345V15.6533C21 15.1425 20.6745 14.6868 20.1869 14.5149C19.7005 14.3435 19.2041 14.2101 18.7021 14.1145M7.21277 12.1295C5.88326 12.1295 4.80547 11.0661 4.80547 9.75435C4.80547 8.44259 5.88326 7.3792 7.21277 7.3792M4.57626 17.5482L4.34039 17.5815C3.63294 17.6812 3 17.1396 3 16.4345V15.6533C3 15.1425 3.3255 14.6868 3.81312 14.5149C4.29952 14.3435 4.79591 14.2101 5.29787 14.1145M9.12765 9.02291C9.12765 10.6924 10.4994 12.0458 12.1915 12.0458C13.8836 12.0458 15.2553 10.6924 15.2553 9.02291C15.2553 7.3534 13.8836 6 12.1915 6C10.4994 6 9.12765 7.3534 9.12765 9.02291ZM15.547 18.9426L15.8472 18.9849C16.7476 19.1118 17.5532 18.4225 17.5532 17.5251V16.5309C17.5532 15.8807 17.1389 15.3007 16.5183 15.0821C13.7203 14.0961 10.6627 14.0961 7.86466 15.0821C7.24406 15.3007 6.82979 15.8807 6.82979 16.5309V17.5251C6.82979 18.4225 7.63535 19.1118 8.53573 18.9849L8.83593 18.9426C11.0617 18.6289 13.3213 18.6289 15.547 18.9426Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
